import { Flame, Settings, Star } from 'lucide-react';

export default function HomePage() {

    
    return (
        <div className="min-h-screen flex flex-col">

{/* Hero Section undraw_quiet-street.svg */}
<section className="astronaut_section pb-40 pt-20 bg-[#fbfef5] min-h-[800px] bg-no-repeat bg-center bg-cover">
  <div className="container-xl mx-auto px-6 flex justify-between items-center max-w-7xl max-w-[85%] gap-15">
    
    {/* Left side */}
    <div className="w-full lg:w-1/2 text-lg">
      <h1 className="titolo-style mb-6 text-left">
        <span className="text-[#131904]" style={{ marginBottom: '10px', display: 'block' }}>
          Cerca, trova, acquista
        </span>
        <span className="text-[#94c41c]" style={{ marginTop: '10px', display: 'block' }}>
          Ottieni il dominio perfetto!
        </span>
      </h1>

      <form action="../search-results" acceptCharset="UTF-8" method="get">
        <div className="relative flex overflow-hidden h-18 border-2 border-[#869d4a] max-w-[750px] rounded-md"
        style={{
            borderRadius: '20px',  // Applica la rotondità direttamente al div
          }}
        >
          <input
            type="text"
            name="terms"
            id="terms"
            placeholder="Cerca qui il tuo dominio ideale..."
            className="flex-grow px-6 py-4 text-xl text-[#869d4a] focus:outline-none h-full"
            style={{ fontSize: '24px'}}  // Arrotondamento solo a sinistra
          />
          <button
            type="submit"
            style={{
              color: '#869d4a',
              padding: '0px 20px',
              borderTopLeftRadius: '0',
              borderBottomLeftRadius: '0',
              borderTopRightRadius: '20px',  // Arrotondamento a destra
              borderBottomRightRadius: '20px',  // Arrotondamento a destra
              border: 'none',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'background-color 0.3s',
            }}
          >
            <svg
              style={{ width: '35px', height: '35px' }}
              fill="none"
              stroke="#869d4a"
              strokeWidth="1.5"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="11" cy="11" r="7" strokeLinecap="round" strokeLinejoin="round" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>
      </form>
    </div>

    {/* Right side (Image) */}
    <div className="hidden lg:block lg:w-1/2">
      <img
        src="/static/immagine_homepage_1.svg"
        alt="Digital Domain"
        className="max-w-full h-auto"
      />
    </div>

  </div>
</section>

{/* Separatore ondulato tra le due parti */}
<div className="relative bg-[#fbfef5] mt-20">
  <div className="absolute bottom-0 left-0 w-full z-10">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1200 120"
      height="120"
      width="100%"
      preserveAspectRatio="none"
      className="block w-full h-full"
    >
      <path
        fill="#f3f9e4"
        d="M0,60 C650,-100 800,180 1200,60 L1200,120 L0,120 Z"
      />
    </svg>
  </div>
</div>


{/* Sezione Vantaggi */}
<section className="bg-[#f3f9e4] py-20 pb-60 w-full">
  <div className="container-xl mx-auto px-6 max-w-[85%]">

    {/* Prima parte: Titolo e descrizione */}
    <div className="text-center mb-16 w-full">
      <h2 className="titolo-style text-5xl text-black mb-6">
        <span className="block text-[#131904]" style={{ marginBottom: '10px', display: 'block' }}>
          Qualunque sia la tua idea,
        </span>
        <span className="block text-[#94c41c]" style={{ marginTop: '10px', display: 'block' }}>
          c'è un dominio perfetto per te!
        </span>
      </h2>
      <p className="regular-text text-[#131904] max-w-full mx-auto inline" style={{fontSize: '25px'}}>
        Il tuo progetto merita di essere trovato, riconosciuto e ricordato. Tutto inizia da un dominio.
      </p>
    </div>

    {/* Seconda parte: Quattro vantaggi */}
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
      {/* Vantaggio 1 */}
      <div className="text-center p-8">
        <img
          src="/static/immagine_homepage_2.svg" // Sostituisci con il path dell'immagine
          alt="Vantaggio 1"
          className="w-80 h-80 mx-auto mb-6"
        />
        <h3
          className="semititolo-style text-2xl text-[#131904] mb-2"
        >
          Creatori ed influencer
        </h3>
        <p className="regular-text text-xl text-[#789a4b]" style={{fontSize: '22px'}}>
          Oggi è il tuo profilo, domani potrebbe essere il tuo brand. Con un dominio personale, chi ti segue saprà sempre dove trovarti, anche al di fuori dei social.
        </p>
      </div>

      {/* Vantaggio 2 */}
      <div className="text-center p-8">
        <img
          src="/static/immagine_homepage__3.svg" // Sostituisci con il path dell'immagine
          alt="Vantaggio 1"
          className="w-80 h-80 mx-auto mb-6"
        />
        <h3 className="semititolo-style text-2xl text-[#131904] mb-2">Business grandi e piccoli</h3>
        <p className="regular-text text-xl text-[#789a4b]" style={{fontSize: '22px'}}>
          Che tu stia avviando un progetto o guidando un'impresa consolidata, ogni attività ha bisogno di una presenza online solida e distintiva.
        </p>
      </div>

      {/* Vantaggio 3 */}
      <div className="text-center p-8">
        <img
          src="/static/immagine_homepage__4.svg" // Sostituisci con il path dell'immagine
          alt="Vantaggio 1"
          className="w-80 h-80 mx-auto mb-6"
        />
        <h3 className="semititolo-style text-2xl text-[#131904] mb-2">Sviluppatori e tech lover</h3>
        <p className="regular-text text-xl text-[#789a4b]" style={{fontSize: '22px'}}> 
          Rendi i tuoi progetti digitali facili da raggiungere con un dominio chiaro, pensato per la tua app, il tuo sito personale o i lavori dei tuoi clienti.
        </p>
      </div>

      {/* Vantaggio 4 */}
      <div className="text-center p-8">
        <img
          src="/static/immagine_homepage__5.svg" // Sostituisci con il path dell'immagine
          alt="Vantaggio 1"
          className="w-80 h-80 mx-auto mb-6"
        />
        <h3 className="semititolo-style text-2xl text-[#131904] mb-2">Artisti e designer</h3>
        <p className="regular-text text-xl text-[#789a4b]" style={{fontSize: '22px'}}>
          Il tuo lavoro è unico, e il tuo dominio dovrebbe esserlo altrettanto. Crea un indirizzo web che valorizzi la tua identità creativa e parli davvero di te.
        </p>
      </div>
    </div>
  </div>
</section>

{/* Separatore ondulato tra le due parti */}
<div className="relative bg-[#fbfef5] mt-0">
  <div className="absolute bottom-0 left-0 w-full z-10">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1200 120"
      height="120"
      width="100%"
      preserveAspectRatio="none"
      className="block w-full h-full"
    >
      <path
        fill="#fbfef5"
        d="M0,60 C650,-100 800,180 1200,60 L1200,120 L0,120 Z"
      />
    </svg>
  </div>
</div>

{/* Sezione punti di forza */}
<section className="astronaut_section pb-24 pt-30 bg-[#fbfef5] bg-no-repeat bg-center bg-cover">
  <div className="container-xl mx-auto px-6 flex justify-between items-center max-w-7xl max-w-[85%] gap-15">
    
    {/* Left side (Image) */}
    <div className="hidden lg:block lg:w-1/2">
      <img
        src="/static/immagine_homepage_6.svg"
        alt="Digital Domain"
        className="max-w-full h-auto"
      />
    </div>

    {/* Right side */}
    <div className="w-full lg:w-1/2 text-lg">
      <h2 className="titolo-style text-left text-5xl text-black mb-6">
        <span className="block text-[#131904]" style={{ marginBottom: '10px', display: 'block' }}>
          Scegliere il dominio giusto?
        </span>
        <span className="block text-[#94c41c]" style={{ marginTop: '10px', display: 'block' }}>
          Ecco come fare!
        </span>
      </h2>
      <p className="regular-text text-[#131904] max-w-full text-left" style={{fontSize: '25px'}}>
        <span>Il dominio giusto è la chiave per farti trovare online.</span><br></br>
        <span>Segui questi tre consigli essenziali per sceglierlo al meglio.</span>
      </p>

      <br></br>
      <h3 className="semititolo-style text-1xl text-[#131904] mb-2 text-left" style={{ fontSize: '1.5em' }}>
        Coerente con il tuo brand
      </h3>
      <p className="regular-text text-[#131904] max-w-full text-left" style={{fontSize: '22px'}}>
        <span>Se hai già un nome per il tuo progetto, scegli un dominio che lo rappresenti. La coerenza rafforza la tua identità online e ne facilita la memorizzazzione.</span>
      </p>

      <br></br>
      <h3 className="semititolo-style text-1xl text-[#131904] mb-2 text-left" style={{ fontSize: '1.5em' }}>
        Chiaro e conciso
      </h3>
      <p className="regular-text text-[#131904] max-w-full text-left" style={{fontSize: '22px'}}>
        <span>Un dominio breve è più facile da leggere e ricordare. Ad esempio, "seeurl.com" è più immediato rispetto a un nome più lungo o complesso.</span>
      </p>

      <br></br>
      <h3 className="semititolo-style text-1xl text-[#131904] mb-2 text-left" style={{ fontSize: '1.5em' }}>
        Facile da digitare
      </h3>
      <p className="regular-text text-[#131904] max-w-full text-left" style={{fontSize: '22px'}}>
        <span>Evita trattini, numeri e lettere ripetute: un dominio semplice diminuisce gli errori e garantisce una migliore condivisione.</span>
      </p>
      
    </div>

  </div>
</section>

{/* Sezione Richiamo Compra Dominio */}
<section className="bg-[#95c11f] text-center py-20 pt-40 pb-40">
  <div className="container-xl mx-auto px-6 max-w-3xl max-w-[85%]">
    {/* Titolo con doppia riga e doppio colore */}
    <h2 className="titolo-style text-center text-5xl text-black mb-6">
        <span className="block text-[#131904]" style={{ marginBottom: '10px', display: 'block', fontSize: '55px'}}>
          Cerca, trova, acquista.
        </span>
        <span className="block text-[#fbfef5]" style={{ marginTop: '10px', display: 'block', fontSize: '55px'}}>
          Ottieni il dominio perfetto!
        </span>
    </h2>

    {/* Search Form */}
    <div className="mt-12 flex justify-center">
      <form action="../search-results" acceptCharset="UTF-8" method="get" className="w-full max-w-[40%]">
        <div
          className="relative flex overflow-hidden h-18 border-2 bg-[#fbfef5]"
          style={{
            borderRadius: '20px',  // Applica la rotondità direttamente al div
          }}
        >
          <input
            type="text"
            name="terms"
            id="terms"
            placeholder="Cerca qui il tuo dominio ideale..."
            className="flex-grow px-6 py-4 text-xl text-[#4b6f32] focus:outline-none h-full placeholder-white"
            style={{ fontSize: '24px', color: '#869d4a'}}
          />
          <button
            type="submit"
            style={{
              color: '#869d4a',
              padding: '0px 20px',
              borderTopLeftRadius: '0',
              borderBottomLeftRadius: '0',
              borderTopRightRadius: '20px',
              borderBottomRightRadius: '20px',
              border: 'none',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'background-color 0.3s',
            }}
          >
            <svg
              style={{ width: '35px', height: '35px' }}
              fill="none"
              stroke="#869d4a"
              strokeWidth="1.5"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="11" cy="11" r="7" strokeLinecap="round" strokeLinejoin="round" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>
      </form>
    </div>

  </div>
</section>


  </div>
    );
}
